
class BadgeConnectConnections extends React.Component {
    constructor(props) {
        super(props);
        this.handleDeleteConnection = this.handleDeleteConnection.bind(this);
        this.handleTabSelect = this.handleTabSelect.bind(this);
        this.state = {
            active: 0, //id of active tab, 0 is "new"
            connections: [],
            existing: [], //assertions already in portfolio, used for comparison
            debug: false
        };
    }

    componentDidMount() {
        let _self = this;
        let urlParams = new URLSearchParams(window.location.search);
        this.setState({ debug: urlParams.get('debug') == "true" });
        httpGet(this.props.connections_url).then(
            function(value) {
                var response = JSON.parse(value);
                if(_self.state.debug){
                    console.info("Loaded Connections", response)
                }

                if(response.length > 0){
                    let hash = location.hash;
                    let split = hash.split("_");
                    let ids = response.map(element => element.id)
                    if(hash.length > 0 && split.length > 1 && ids.indexOf(parseInt(split[1])) > -1 ){
                        _self.setState({ connections: response, active: parseInt(split[1]) });
                    } else {
                        _self.setState({ connections: response, active: response[0].id });
                    }
                } else {
                    _self.setState({ connections: response });
                }
            })
        .catch(
            function(reason) {
                alertify.error('Unable to Retrieve List of Connections')
            });
    }

    handleDeleteConnection(connectionid){
        // called upon successful delete, remove item from connections array
        let newConnections = [...this.state.connections].filter(item => item.id !== connectionid);
        this.setState({
            connections: newConnections,
            active: (newConnections.length > 0) ? newConnections[0].id : 0
        });
    }

    handleTabSelect(tabid) {
        //Select by id (int). Uses host record id. 0 == overview/new tab
        this.setState({ active: parseInt(tabid) });
    }

    render() {
        // console.log(this.props)
        const backpacktabs = this.state.connections.map((connection) =>
            <BadgeConnectTab settings={connection} key={connection.id} active={this.state.active} handleTabSelect={this.handleTabSelect} />
        );

        const backpacks = this.state.connections.map((connection) =>
            <BadgeConnectBackpack portfolioid={this.props.portfolioid} settings={connection} key={connection.id} active={(this.state.active==connection.id)} handleDeleteConnection={this.handleDeleteConnection} debug={this.state.debug} />
        );

        return (
            <section className="bc-connections">
                {/* Requires .tabs-decorative to prevent regular js plugin from binding */}
                <ul className="tabs tabs--leftsquared tabs--decorative" role="tablist">
                    {backpacktabs}
                    <li role="presentation" className="tabs-tab">
                        {this.state.active == 0 && (
                        <a href="#bctab_0" aria-controls="bctab_0" role="tab" aria-selected="true" className="is-active" onClick={() => this.handleTabSelect(0)}><StaticImage path="assets/images/badge-connect-symbol.png" classes="tab-logo" altText="Badge Connect" /> New Connection</a>
                        )}
                        {this.state.active != 0 && (
                        <a href="#bctab_0" aria-controls="bctab_0" role="tab" aria-selected="false" onClick={() => this.handleTabSelect(0)}><StaticImage path="assets/images/badge-connect-symbol.png" classes="tab-logo" altText="Badge Connect" /> New Connection</a>
                        )}
                    </li>
                </ul>

                {backpacks}
                <BadgeConnectOverviewTab active={this.state.active == 0} add_url={this.props.add_url} />
                
            </section>
        );
    }
}


class BadgeConnectTab extends React.Component {
    constructor(props) {
        super(props);
        this.handleSomeEvent = this.handleSomeEvent.bind(this);
    }

    handleSomeEvent(event) {

    }

    render() {
        var previewSettings = JSON.stringify(this.props.settings, undefined, 4);
        let isActive = this.props.active == this.props.settings.id;

        return (
            <li role="presentation" className="tabs-tab">
                {/* <pre>{previewSettings}</pre> */}
                <a href={"#bctab_" + this.props.settings.id} aria-controls={"bctab_" + this.props.settings.id} role="tab" aria-selected={(isActive) ? "true" : "false"} className={(isActive) ? "is-active" : null}  onClick={() => this.props.handleTabSelect(this.props.settings.id)}>
                    <img className="tab-logo" src={this.props.settings.host.image} alt={this.props.settings.host.name} /> 
                    {/* {this.props.settings.host.name} */}
                </a>
            </li>
        );
    }
}

class BadgeConnectBackpack extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = this.fetchData.bind(this);
        this.handleDeleteConnection = this.handleDeleteConnection.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleShowDetails = this.handleShowDetails.bind(this);
        this.handleImportHosted = this.handleImportHosted.bind(this);
        this.handleImportAll = this.handleImportAll.bind(this);
        this.handlePaginate = this.handlePaginate.bind(this);
        this.state = {
            loading: false,
            fetched: false,
            failed: false,
            expired: false,
            page: 1,
            limit: 6,
            offset: 0,
            results: [],
            status: {},
            pagination: {},
            importing: [], //in progress
            imported: [], //assertions imported this session
            failedImports: [], //failed to import
            modalOpen: false,
            modalGraph: null,
            modalUuid: ""
        };
    }

    componentDidMount() {
        if(this.props.active) {
            this.fetchData();
        }
    }

    componentWillReceiveProps(newProps) {
        if(newProps.active && !this.state.fetched) {
            this.fetchData();
        }
    }
    
    fetchData() {
        let _self = this;

        /*
        "expires": "2020-02-07T11:44:40.938693-05:00",
        "refresh_token_id": null,
        */

        //if expired and no refresh token, we can only request they delete and reconnect
        let expired = new Date(this.props.settings.expires) < new Date().getTime();
        if(expired && this.props.settings.refresh_token_id == null){
            this.setState({ expired: true })
        } else {
            this.setState({ loading: true }, () => {
                httpGet(buildRoute(mantlroutes.bc_host_connection_assertions, { 'connectionid': this.props.settings.id }) + formatParams({
                    limit: _self.state.limit,
                    offset: _self.state.offset
                })).then(
                    function(value) {
                        let response = JSON.parse(value);
                        if(_self.props.debug){
                            console.info("Loaded Connection Assertions", response)
                        }
                        // console.info("Backpack initially loaded", response)
                        let results = (response.assertions || []).concat(response.signedAssertions || []);
                        _self.setState({ 
                            loading: false, 
                            fetched: true,
                            results: results,
                            status: response.status,
                            pagination: response.pagination
                        });
                    })
                .catch(
                    function(reason) {
                        _self.setState({ 
                            loading: false,
                            fetched: true,
                            failed: true,
                        });
                        console.error('Error trying to load backpack.', reason);
                        alertify.error("Error trying to load backpack.")
                    });
    
            });
        }
    }

    handleDeleteConnection() {
        let _self = this;

        alertify.okBtn("Delete Connection").confirm("<h1 class='h4 text--danger'>Are you sure you want to delete this connection?</h1><p>Don't worry. You will not lose any badges that have already been imported.</p>")
            .then(function (resolvedValue) {
                resolvedValue.event.preventDefault();
                if(resolvedValue.buttonClicked == "ok"){
                    console.info('delete connection');

                    httpDelete(buildRoute(mantlroutes.bc_host_connection, { 'connectionid': _self.props.settings.id })).then(
                        function(value) {
                            //callback to parent component
                            _self.props.handleDeleteConnection(_self.props.settings.id);
                            alertify.log('Connection Deleted');
                        })
                    .catch(
                        function(reason) {
                            console.error('Error trying to delete connection to backpack.', reason);
                            alertify.error("Error trying to delete connection to backpack.")
                        });
                }
            })

        
    }

    handleOpenModal(){
        this.setState({ modalOpen: true });
    }

    handleCloseModal(){
        this.setState({ modalOpen: false });
    }

    handleShowDetails(graph,uuid) {
        this.setState({ 
            modalGraph: graph,
            modalUuid: uuid,
            modalOpen: true,
        });
    }

    handlePaginate(offset){
        this.setState({ 
            offset: offset
        }, () => {
            this.fetchData();
        });
    }

    handleImportAll() {
        // const assertionURLs = this.state.results.map( item =>{
        //     return item.id;
        // });
        this.handleImportHosted(this.state.results)
    }

    // using the middle component of the JWT as assertion id if assertion is signed
    getId(assertion) {
        return typeof assertion === 'string' ? assertion.split('.')[1] : assertion.id;
    }

    handleImportHosted(assertions) {
        let _self = this;
        let endpoint = buildRoute(mantlroutes.portfolio_badges,{ portfolioid: this.props.portfolioid }) + formatParams({
            'dry-run': false
        });
        //Tell the state this is being imported
        let curImporting = this.state.importing;
        if(assertions == null){
            console.error('handleImportHosted() called without an assertion');
            return false;
        }
        //Accept string input for one value
        if(assertions.constructor !== Array) {
            assertions = [assertions];
        }
        // console.info('curImporting',this.state.importing);
        // console.info('assertions to import, before filter',assertions);
        //don't try to re-import in-progres
        let component = this;
        assertions = assertions.filter(function(item){
            return curImporting.indexOf(component.getId(item)) === -1;
        });
        // console.info('assertions to import, after filter',assertions);
        let importingIDs = assertions.map(item => component.getId(item));
        // console.info('setting state of importing',importingIDs,[...this.state.importing, ...importingIDs]);

        this.setState({
            importing: [...this.state.importing, ...importingIDs]
        })

        assertions.forEach(assertion => {
            //iterate over each hosted assertion id            
            let formData = {
                'json_badge': (typeof assertion === 'string' ? assertion : JSON.stringify(assertion))
            }
            var assertion_id = component.getId(assertion);
            httpPost(endpoint, formData).then(
                (value) => {
                    var response = JSON.parse(value);
                    //update the results element with a new date
                    let idx = this.state.results.findIndex(item => component.getId(item) === assertion_id)
                    let results = this.state.results;
                    results[idx].last_imported = response.last_imported; //create validation record in the result

                    this.setState({
                        results: results,
                        importing: [...this.state.importing].filter(item => item !== assertion_id),
                        failedImports: [...this.state.importing].filter(item => item !== assertion_id),
                        imported: [...this.state.imported, assertion_id]
                    });
                })
            .catch(
                (reason) => {
                    
                    this.setState({
                        importing: [...this.state.importing].filter(item => item !== assertion_id),
                        failedImports: [...this.state.failedImports, assertion_id]
                    });
                    console.error('Error importing assertion.', assertion_id, reason);
                    // alertify.error('There was an error trying to validate ' + _self.props.assertion.id );
                });
            
        });
    }

    render() {
        var previewSettings = JSON.stringify(this.props.settings, undefined, 4);
        var previewStatus = JSON.stringify(this.state.status, undefined, 4);
        var previewResults = JSON.stringify(this.state.results, undefined, 4);
        var previewPagination = JSON.stringify(this.state.pagination, undefined, 4);

        const tabStyle = {
            display: (this.props.active) ? "block" : "none",
        };

        let component = this;
        const assertions = this.state.results.map((assertion,index) =>
            <BadgeConnectAssertion portfolioid={this.props.portfolioid} assertion={assertion} key={"assertion_" + component.getId(assertion)} handleShowDetails={this.handleShowDetails} handleImportHosted={this.handleImportHosted} importing={this.state.importing} imported={this.state.imported} failedImports={this.state.failedImports} debug={this.props.debug} />
        );

        return (
            <section role="tabpanel" id={"bctab_" + this.props.settings.id} style={tabStyle}>
                {this.state.failed && (
                    <div className="alert alert--error"><Icon classes="icon-exclamation-circle"></Icon> Something went wrong loading the connection...</div>
                )}
                {this.state.expired && (
                    <div className="alert alert--secondary"><p><b><Icon classes="icon-exclamation-circle"></Icon> This connection has permanently expired.</b> <br />Please delete and start a new connection.</p></div>
                )}
                {this.state.results.length==0 && this.state.fetched && (
                    <div className="alert"><Icon classes="icon-exclamation-circle"></Icon> No assertions returned.</div>
                )}
                
                {this.state.results.length > 0 && (
                <p className="text--center" style={{"marginTop":"1em","marginBottom":"0px"}}><button className="button button--secondary" onClick={this.handleImportAll}><Icon classes="icon-check" /> Import All</button></p>
                )}

                {this.state.loading && (
                    <LoadingSpinner />
                )}

                <div className="badge-grid--flex bc-connection">
                    {assertions}
                </div>
                
                <div>
                    {this.state.results.length > 0 && this.state.pagination.count > this.state.limit && (
                        <PaginationOffsetLimit classes="nav-group nav-group--inline" onChangePage={this.handlePaginate} count={this.state.pagination.count} limit={this.state.limit} offset={this.state.offset} />
                    )}
                    <button className="button--skinny button--sm button--bordered border--danger" onClick={this.handleDeleteConnection}>Delete Connection</button>
                </div>                
                
                
                {/* <pre>{previewStatus}</pre>
                <pre>{previewResults}</pre>
                <pre>{previewPagination}</pre>
                <hr />
                <pre>{previewSettings}</pre> */}

                {this.state.modalGraph != null && (
                    <Modal
                        open={this.state.modalOpen}
                        handleOpen={this.handleOpenModal}
                        handleClose={this.handleCloseModal}
                        labelledby={"trigger_" + this.state.modalUuid}
                        classes="modal--large animated animated--quickly puffIn"
                        headerText="Badge Details"
                        escClose={true}
                        backgroundClose={true}
                    >
                        <BadgeConnectAssertionDetails graph={this.state.modalGraph} />
                    </Modal>
                )}
                

            </section>
        );
    }
}

//Each assertion needs to expand the json-ld and load up individually
//Then compare against existing
class BadgeConnectAssertion extends React.Component {
    constructor(props) {
        super(props);
        this.handleDisplayValidation = this.handleDisplayValidation.bind(this);
        this.handleImportAssertion = this.handleImportAssertion.bind(this);
        this.state = {
            error: false,
            reason: "",
            loading: true,
            assertion: this.props.assertion,
            validated: false, //completed validation process
            valid: false,
            graph: null,
            report: null,
            json_badge: null,
            url_badge: null,
            last_imported: null
        };
    }

    handleDisplayValidation() {
        let reportHTML = getValidatorResultHTML(this.state.report);
        //TODO, create non jquery modal
        var $modal = buildModal(reportHTML,{
            classes: 'modal modal--flat',
            header: "Badge Validation Report"
        });
        $('body').append($modal);
        $modal.on("modal:close",function(){
            $modal.off("modal:close").remove();
        })
        $modal.openModal();
    }

    componentWillReceiveProps(newProps) {
        // console.log(newProps, newProps.assertion);
        if(newProps.assertion.last_imported != null && newProps.assertion.last_imported != undefined){
            this.setState({
                last_imported: newProps.assertion.last_imported
            });
        }
    }

    // using the middle component of the JWT as assertion id if assertion is signed
    getId(assertion) {
        return typeof assertion === 'string' ? assertion.split('.')[1] : assertion.id;
    }

    componentDidMount() {
        let _self = this;
        let formData = {
            // 'url_badge': this.props.assertion.id
            'json_badge' : typeof this.props.assertion === 'string' ? this.props.assertion : JSON.stringify(this.props.assertion)
        }
        let endpoint = buildRoute(mantlroutes.portfolio_badges,{ portfolioid: this.props.portfolioid }) + formatParams({
            'dry-run': true
        });

        //in case I figure out how to preemptively pass it along
        if(this.props.assertion.validation != null){
            this.setState({
                loading: false,
                graph: this.props.assertion.validation.result.graph,
                valid: this.props.assertion.validation.result.report.valid,
                validated: true,
                report: this.props.assertion.validation.result.report,
                json_badge: this.props.assertion.validation.json_badge,
                url_badge: this.props.assertion.validation.url_badge,
                last_imported: this.props.assertion.validation.last_imported
            });
        } else {
            if(_self.props.debug){
                console.info("Validating...", formData);
            }
            httpPost(endpoint, formData).then(
                function(value){
                    var response = JSON.parse(value);
                    // console.log(response)
                    if(_self.props.debug){
                        console.info("Dry Run Result Report", response.result.report);
                        console.info("Dry Run Result Graph", response.result.graph);
                        console.info("Dry Run Last Imported", response.last_imported);
                    }
                    _self.setState({
                        loading: false,
                        graph: response.result.graph,
                        valid: response.result.report.valid,
                        validated: true,
                        report: response.result.report,
                        json_badge: response.json_badge,
                        url_badge: response.url_badge,
                        last_imported: response.last_imported
                    });
                })
            .catch(
                function(reason) {
                    _self.setState({
                        error: true,
                        reason: reason,
                        loading: false,
                        validated: true //process completed, not that it is valid
                    });
                    console.error('Error calling badge validator.', reason);
                    // alertify.error('There was an error trying to validate ' + _self.props.assertion.id );
                });
        }

        
    }

    handleImportAssertion() {
        this.props.handleImportHosted(this.props.assertion)
    }

    render() {
        let importing = this.props.importing.indexOf(this.getId(this.props.assertion)) > -1;
        let failedImport = this.props.failedImports.indexOf(this.getId(this.props.assertion)) > -1;
        //var assertion = JSON.stringify(this.props.assertion, undefined, 4);
        let uuid = generateUUID();

        if(this.state.loading) {
            return (
                <figure className="badge">
                    <div className="badge-face badge-front">
                    <LoadingSpinner />
                    </div>
                </figure>
            );
        }

        if (this.state.graph != null) {
            const classes = (this.state.last_imported != null) ? "badge badge--graph is-imported" : "badge badge--graph";
            let imgSrc = this.state.graph[2].image;
            let imgAlt = this.state.graph[2].name + " artwork";
            if(typeof this.state.graph[2].image == 'object') {
                imgSrc = this.state.graph[2].image.id;
                if(this.state.graph[2].image.caption != undefined && this.state.graph[2].image.caption != null){
                    imgAlt = this.state.graph[2].image.caption;
                }
            }

            return (
                <figure className={classes}>
                    <div className="badge-face badge-front">

                        <figcaption className="badge-name">{this.state.graph[2].name}</figcaption>
                        <img className="badge-art" src={imgSrc} alt={imgAlt} onClick={ () => this.props.handleShowDetails(this.state.graph,uuid) } />
                        <p className="badge-flags">
                            <button className="button--sm button--skinny button--primary" onClick={ () => this.props.handleShowDetails(this.state.graph,uuid) } id={"trigger_" + uuid}>Details</button><span> </span>
                            {/* {this.state.valid && (<button className="button--sm button--skinny button--success" onClick={this.handleDisplayValidation}>Valid</button>)} */}
                            {!this.state.valid && (<button className="button--sm button--skinny button--error" onClick={this.handleDisplayValidation}>Invalid</button>)}
                        </p>
                        <hr />
                        
                        <p>
                            {this.state.last_imported == null && !importing && (
                                <button className="button button--secondary button--skinny" onClick={this.handleImportAssertion}>Import</button>
                            )}
                            {this.state.last_imported != null && !importing && (
                                <button className="button button--muted button--skinny" onClick={this.handleImportAssertion}>Re-Import</button>
                            )}
                        </p>
                        {importing == true && (
                            <LoadingSpinner />
                        )}
                        {failedImport == true && (
                            <p className="badge-error-msg">
                                <Icon classes="icon-exclamation-circle icon--error"></Icon> Import Failed 
                            </p>
                        )}
                        {this.state.last_imported != null && (
                            <p className="text--sm"><Icon classes="icon-check-circle icon--success" /> Imported on <b><FormattedDate date={this.state.last_imported} /></b></p>
                        )}
                        {this.state.last_imported == null && (
                            <p className="text--sm"><i>Import will copy this badge into your portfolio</i></p>
                        )}

                    </div>
                </figure>
            );
        } else {
            return (
                <figure className="badge badge--error">
                    <div className="badge-face badge-front">
                        {this.state.validated && (
                        <p className="badge-error-msg">
                            <Icon classes="icon-exclamation-circle icon--error"></Icon> Error Expanding Badge Assertion 
                        </p>
                        )}
                        {!this.state.validated && (
                        <p className="badge-error-msg">
                            <Icon classes="icon-exclamation-circle icon--error"></Icon> Error Completing Validation 
                        </p>
                        )}
                    </div>
                </figure>
            );
        }
        
    }
}


//New Connection Tab
function BadgeConnectOverviewTab(props) {
    const tabStyle = {
        display: ((props.active) ? "block" : "none"),
    };
    
    return (
        <section role="tabpanel" id="bctab_0" style={tabStyle} className="text--center">
            <h2 className="h3">Take Advantage of Open Badges 2.1</h2>
            <p className="introduction">Badge Connect is the latest feature of Open Badges 2.1, which allows <br />you to easily move and update Open Badges between platforms.<br /> <b className="text--tertiary">Look for this symbol</b> <img src={mantl.static_url + 'assets/images/badge-connect-symbol.svg' } alt="Badge Connect" className="icon--svg" /></p>
            <p className="text--loosetop text--xl">
                <a href={props.add_url} className="add-disc-button"><span>+</span> NEW CONNECTION</a>
            </p>

            <div><StaticImage path="assets/images/onboarding-badge-connect.svg" classes="image--onboarding" altText="An illustration of a road with various life stages, all connecting to a central portfolio that can import badges." /></div>
        </section>
    );
}

class BadgeConnectStatusReport extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="text--center text--smaller">
                <p>
                    <code><Icon classes="icon-circle icon--error icon--smaller" /> {this.props.status.statusCode}</code> <code>{this.props.status.statusText}</code> {this.props.status.error}
                </p>
            </div>
        );
    }
}

function BadgeConnectAssertionDetails(props) {
    let skills = []
    if(props.graph[2].tags.constructor === Array) {
        skills = props.graph[2].tags.map((skill, index) =>
            <BadgeConnectAssertionSkill skill={skill} key={index} />
        );
    } else if (typeof props.graph[2].tags === 'string') {
        // skills.push(props.graph[2].tags)
        skills.push(<BadgeConnectAssertionSkill skill={props.graph[2].tags} />)
    }

    // console.info(props.graph);
    let imgSrc = props.graph[2].image;
    let imgAlt = props.graph[2].name + " artwork";
    if(typeof imgSrc == 'object') {
        imgSrc = imgSrc.id;
        if(imgSrc.caption != undefined && imgSrc.caption != null){
            imgAlt = imgSrc.caption;
        }
    }
    
    return (
        <div className="row">
            <div className="column-4 column-plus1 text--center">
                <h3 className="h4">{props.graph[2].name}</h3>
                <img className="badge-art" src={imgSrc} alt={imgAlt} />
            </div>

            <div className="column-6 column-plus1 text--left">
                <h4 className="h5"><span className="text--med">Issued on <b><FormattedDate date={props.graph[1].issuedOn} /></b></span><br />
                <b>By</b><span className="enspace"> </span><img src={props.graph[3].image} className="badge-disc" alt={props.graph[3].name} /> <a href={props.graph[3].url} target="_blank">{props.graph[3].name}</a></h4>
                <p><b>Badge Description</b><br />{props.graph[2].description}</p>
                <div className="badge-skills">{skills}</div>
                <h4 className="h6"><a href={props.graph[2].criteria.id} target="_blank">Badge Criteria</a></h4>
                <p>
                    <Markdown source={props.graph[2].criteria.narrative} />
                </p>
            </div>

        </div>
    );
}

function BadgeConnectAssertionSkill(props) {
    return (
        <span className="flag flag--badged">{props.skill}</span>
    );
}
